import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Button,
  Card,
  CardContent,
  Grid,
  Link,
  Paper,
  Typography,
} from '@mui/material';
import {
  TrendingUp as IdeaIcon,
  Science as ResearchIcon,
  ArrowForward as ArrowForwardIcon,
} from '@mui/icons-material';

const AppSuccessDashboard: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Box>
      <Typography variant="h4" sx={{ fontWeight: 700, mb: 1 }}>
        App Success Platform
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
        One workspace to research, create assets, optimize listings, and scale app growth.
      </Typography>

      <Paper sx={{ p: 2.5, mb: 3 }}>
        <Typography variant="h6" sx={{ mb: 1 }}>
          Quick Start
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Start from a new app idea or research an existing live app to build strategy and execution plans.
        </Typography>
      </Paper>

      <Paper sx={{ p: 2.5, mb: 3 }}>
        <Typography variant="h6" sx={{ mb: 1 }}>
          Boilerplate Repository
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5 }}>
          Use the official starter repo to bootstrap implementation quickly.
        </Typography>
        <Typography variant="body2" sx={{ mb: 1.5 }}>
          <strong>Repo:</strong>{' '}
          <Link
            href="https://github.com/wejeel/core-builder"
            target="_blank"
            rel="noopener noreferrer"
            underline="hover"
          >
            github.com/wejeel/core-builder
          </Link>
        </Typography>
        <Button
          variant="outlined"
          component="a"
          href="https://github.com/wejeel/core-builder"
          target="_blank"
          rel="noopener noreferrer"
        >
          Open Boilerplate Repo
        </Button>
      </Paper>

      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <Card variant="outlined" sx={{ height: '100%' }}>
            <CardContent>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                <IdeaIcon color="primary" />
                <Typography variant="h6">New App Idea Research</Typography>
              </Box>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                Validate market opportunity, audience, and launch direction for a brand-new app concept.
              </Typography>
              <Button
                variant="contained"
                endIcon={<ArrowForwardIcon />}
                onClick={() => navigate('/app-idea-research')}
              >
                Start Idea Research
              </Button>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} md={6}>
          <Card variant="outlined" sx={{ height: '100%' }}>
            <CardContent>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                <ResearchIcon color="primary" />
                <Typography variant="h6">Existing App Research</Typography>
              </Box>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                Analyze a live app from store link or app name to extract insights, positioning, and opportunities.
              </Typography>
              <Button
                variant="contained"
                endIcon={<ArrowForwardIcon />}
                onClick={() => navigate('/app-research')}
              >
                Start App Research
              </Button>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
};

export default AppSuccessDashboard;
